import { Routes } from '@angular/router';
import { authGuard } from './shared/gaurds/auth.guard';
import { noAuthGuard } from './shared/gaurds/no-auth.guard';
import { AppRouteSegment } from './globals/app-routepath';
import { passwordResetGuard } from './shared/gaurds/password-reset.guard';

export const routes: Routes = [
    {
        path: AppRouteSegment.AUTH.LOGIN,
        loadChildren: () =>
            import('./modules/auth/auth.module').then((m) => m.AuthModule),
        canActivate: [noAuthGuard],
    },
    {
        path: AppRouteSegment.DASHBOARD.ROOT,
        loadChildren: () =>
            import('./modules/dashboard/dashboard.module').then(
                (m) => m.DashboardModule
            ),
        canActivate: [authGuard, passwordResetGuard],
        data: {
            role: ['admin', 'talent', 'visitor', 'panel', 'manager', 'super-admin', 'HR Operation','employee'],
        },
    },
    {
        path: AppRouteSegment.WRITTEN.ROOT,
        loadChildren: () =>
            import('./modules/written-station/written-station.module').then(
                (m) => m.WrittenStationModule
            ),
        canActivate: [passwordResetGuard],
    },
    {
        path: AppRouteSegment.TECHNICAL.ROOT,
        loadChildren: () =>
            import('./modules/technical-station/technical-station.module').then(
                (m) => m.TechnicalStationModule
            ),
        canActivate: [passwordResetGuard],
    },
    {
        path: AppRouteSegment.HR.ROOT,
        loadChildren: () =>
            import('./modules/hr-station/hr-station.module').then(
                (m) => m.HrStationModule
            ),
        canActivate: [authGuard, passwordResetGuard],
        data: {
            role: ['admin', 'talent', 'manager', 'super-admin', 'HR Operation'],
        },
    },
    {
        path: AppRouteSegment.USER.ROOT,
        loadChildren: () =>
            import('./modules/user/user.module').then((m) => m.UserModule),
        canActivate: [passwordResetGuard],
    },
    {
        path: AppRouteSegment.MANAGEMENT.ROOT,
        loadChildren: () =>
            import('./modules/management/management.module').then(
                (m) => m.ManagementModule
            ),
        canActivate: [authGuard, passwordResetGuard],
        data: {
            role: ['admin', 'manager', 'super-admin', 'HR Operation', 'talent'],
        },
    },
    { path: '**', redirectTo: AppRouteSegment.AUTH.LOGIN, pathMatch: 'full' },
];
